
import {
  Component,
  Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  BoxStatusType,
} from '@/types';
import { isTaskCompleted, isTaskFailed } from '@/helpers';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationAuth extends Mixins(OperationComponentMixin) {
  chipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey lighten-2';

      case 'done':
        return 'statusDone';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  chipOutlined(value: BoxStatusType | null): boolean {
    switch (value) {
      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  tooltipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  tooltipText(prefix: string, value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return `${prefix} (assente)`;

      case 'na':
        return `${prefix} (non applicabile)`;

      case 'waiting':
        return `${prefix} (in attesa di terzi)`;

      default:
        break;
    }
    return prefix;
  }

  get tChipColor(): string {
    return this.operation
      ? this.chipColor(this.operation?.titoloAutorizzativo)
      : '';
  }

  get tChipOutlined(): boolean {
    return this.operation
      ? this.chipOutlined(this.operation?.titoloAutorizzativo)
      : false;
  }

  get tTooltipColor(): string {
    return this.operation
      ? this.tooltipColor(this.operation?.titoloAutorizzativo)
      : '';
  }

  get tTooltipText(): string {
    return this.operation
      ? this.tooltipText('Titolo autorizzativo', this.operation?.titoloAutorizzativo)
      : 'Titolo autorizzativo';
  }

  get hasNotes(): boolean {
    return this.operation?.hasTitoloAutorizzativoNotes === true;
  }

  get columnClass(): string {
    if (isTaskCompleted(this.operationChild, 'V')) return 'completed';
    if (isTaskFailed(this.operationChild, 'V')) return 'error';
    if (this.operation?.titoloAutorizzativo === 'done') return 'completed';
    return '';
  }

  onEdit() {
    console.log('OperationAuth: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
